module.exports = __webpack_public_path__ + "img/booster_juice.354fb7d5.jpg";